import { render, staticRenderFns } from "./XdataInsertRowControl.vue?vue&type=template&id=ca09d0ca&"
import script from "./XdataInsertRowControl.vue?vue&type=script&lang=js&"
export * from "./XdataInsertRowControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports